<template>
  <div class="editInformation">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="onSubmit"
    >
      <van-popover
        v-model="showPopover"
        :actions="nameList"
        @select="onSelectPopover"
        theme="dark"
        :offset="[35, 35]"
      >
        <template #reference>
          <van-field
            v-model="form.CompanyName"
            :label="$t.information.companyName"
            :placeholder="$t.information.input"
            required
            :rules="[
              {
                required: true,
                message: $t.information.input + ' ' + $t.information.companyName,
              },
              {
                validator: asyncValidator,
                message: $t.information.validator,
              },
            ]"
          />
        </template>
      </van-popover>
      <van-field
        v-model="form.CompanyNameEn"
        :label="$t.information.companyNameEn"
        :placeholder="$t.information.input"
        required
        :rules="[
          {
            required: true,
            message: $t.information.input + ' ' + $t.information.companyNameContact,
          },
        ]"
      />
      <van-field
        v-model="form.CompanyNameSn"
        :label="$t.information.companyNameSn"
        :placeholder="$t.information.input"
        type="textarea"
      />
      <van-field
        v-model="form.LegalPerson"
        :label="$t.information.companyNameContact"
        :placeholder="$t.information.input"
        required
        :rules="[
          {
            required: true,
            message: $t.information.input + ' ' + $t.information.companyNameContact,
          },
        ]"
      />
      <van-field
        v-model="form.TelePhone"
        :label="$t.information.telePhone"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.WebSite"
        :label="$t.information.webSite"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.Address"
        :label="$t.information.address"
        :placeholder="$t.information.input"
        type="textarea"
      />
      <van-field :label="$t.information.certificate">
        <template #input>
          <van-uploader v-model="images" :max-count="1" :after-read="afterRead" />
        </template>
      </van-field>
      <van-field
        v-model="form.PersonalPassport"
        :label="$t.information.personalPassport"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.PersonalID"
        :label="$t.information.personalID"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.CustomerPhone"
        :label="$t.information.customerPhone"
        :placeholder="$t.information.input"
        required
        :rules="[
          {
            required: true,
            message: $t.information.input + ' ' + $t.information.customerPhone,
          },
        ]"
      />
      <van-field
        v-model="form.Email"
        :label="$t.information.email"
        :placeholder="$t.information.input"
        required
        :rules="[
          {
            required: true,
            message: $t.information.input + ' ' + $t.information.email,
          },
        ]"
      />
      <van-field
        readonly
        clickable
        :value="country.text"
        :label="$t.information.country"
        :placeholder="$t.information.select"
        @click="onShowCountry"
        required
        :rules="[
          {
            required: true,
            message: $t.information.select + ' ' + $t.information.country,
          },
        ]"
      />
      <van-field
        readonly
        clickable
        :value="city.text"
        :label="$t.information.city"
        :placeholder="$t.information.select"
        @click="onShowCity"
        required
        :rules="[
          {
            required: true,
            message: $t.information.select + ' ' + $t.information.city,
          },
        ]"
      />
      <van-field
        v-model="form.Password"
        :type="showPassword ? 'text' : 'password'"
        :label="$t.information.password"
        :placeholder="$t.information.input"
        required
        :rules="[
          {
            required: true,
            message: $t.information.input + ' ' + $t.information.password,
          },
        ]"
      >
        <template #button>
          <van-icon
            name="eye-o"
            v-if="showPassword"
            @click="showPassword = !showPassword"
          />
          <van-icon name="closed-eye" v-else @click="showPassword = !showPassword" />
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button
          block
          type="info"
          color="#2750aa"
          style="border-radius: 10px"
          native-type="submit"
          >{{ $t.information.submit }}</van-button
        >
      </div>
    </van-form>

    <option-list
      event="showInfoCountrys"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showInfoCities"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Uploader, Icon, Popover } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Button).use(Uploader).use(Icon).use(Popover);
export default {
  name: "editInformation",
  components: {
    OptionList,
  },
  data() {
    return {
      language: localStorage.getItem("requestLanguage") || "auto",
      countryList: [],
      country: {
        text: "",
        value: "",
      },
      cityList: [],
      city: { text: "", value: "" },
      images: [],
      showPassword: false,
      form: {
        CompanyName: "",
        CompanyNameEn: "",
        CompanyNameSn: "",
        LegalPerson: "",
        TelePhone: "",
        WebSite: "",
        Address: "",
        Certificate: "",
        PersonalPassport: "",
        PersonalID: "",
        CustomerPhone: "",
        Email: "",
        CountryId: null,
        CityId: null,
        Password: "",
      },
      showPopover: false,
      nameList: [],
    };
  },
  created() {
    const query = this.$route.query;
    if (query.IsNew) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
        msg: this.$t.information.alert,
      });
    }
    this.getCustomerPersonalInfo().then((success) => {
      if (success) {
        this.getCountryList().then((success) => {
          if (success) this.getCityList(this.country.value, false);
        });
      }
    });
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    getCustomerPersonalInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {};
        this.$api.user
          .getCustomerPersonalInfo(param)
          .then((res) => {
            this.form = res.data;
            this.country.text = this.form.CountryName;
            this.country.value = this.form.CountryId;
            this.city.text = this.form.CityName;
            this.city.value = this.form.CityId;
            if (this.form.Certificate) {
              this.images.push({
                url: this.imgUrlFilter(this.form.Certificate),
              });
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    asyncValidator() {
      return new Promise((resolve) => {
        var param = {
          CompanyName: this.form.CompanyName,
        };
        this.$api.user
          .checkCustomerCompanyNameExists(param)
          .then((res) => {
            var data = res.data;
            if (data.IsCompanyNameRepeat) {
              var nameList = [];
              for (var name of data.CompanyNameList) {
                nameList.push({
                  text: name,
                });
              }
              this.nameList = nameList;
              this.showPopover = true;
              resolve(false);
            } else {
              resolve(true);
            }
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSelectPopover(value) {
      this.form.CompanyName = value.text;
    },
    onShowCountry() {
      this.$bus.$emit("showInfoCountrys", true);
    },
    onSelectCountry(item) {
      this.country.text = item.text;
      this.country.value = item.value;
      this.getCityList(item.value, true);
    },
    onShowCity() {
      this.$bus.$emit("showInfoCities", true);
    },
    onSelectCity(item) {
      this.city.text = item.text;
      this.city.value = item.value;
    },
    getCountryList() {
      var param = {
        BusinessType: 1,
      };
      return new Promise((resolve) => {
        this.$api.user
          .getTakeDeliveryCountryCityList(param)
          .then((res) => {
            this.formatCountry(res.data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatCountry(data) {
      var result = [];
      data.forEach((item) => {
        var cityList = [];
        if (item.CityList) {
          for (var city of item.CityList) {
            cityList.push({
              text: this.language == "zh" ? city.City_cn : city.City_en,
              value: city.CityId,
            });
          }
        }
        let data = {
          text: this.language == "zh" ? item.CountryName : item.CountryName_en,
          value: item.CountryId,
          cityList: cityList,
        };
        result.push(data);
      });
      this.countryList = result;
    },
    getCityList(countryId, isReset) {
      for (let country of this.countryList) {
        if (country.value == countryId) {
          this.cityList = country.cityList;
          if (isReset) {
            this.city.text = "";
            this.city.value = null;
          }
        }
      }
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CountryId = this.country.value;
      param.CountryName = this.country.text;
      param.CityId = this.city.value;
      param.CityName = this.city.text;
      this.$api.user
        .editCustomerPersonalInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: false,
            path: "home",
            name: "Home",
            query: [],
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].message,
        });
      }
    },
    afterRead(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.user
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.Certificate = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.editInformation {
  ::v-deep .van-form {
    .van-cell__title {
      flex: unset !important;
    }
  }
  .van-popover__wrapper {
    width: 100%;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
